export const deliverOrderList = {
  clickListItem: 'n.3389.6081.0', // 点击运单列表页的运单
  shareList: 'n.3389.6726.0' // 列表页点击发送给同事（分享按钮）
}
